(function () {
  const initProductAccordion = () => {
		$(".about__accordion-toggle").click(function () {
			if (!$(this).hasClass("active")) {
				$(this).addClass("active");
				$(this)
					.siblings(".about__accordion-description")
					.eq($(this).index())
					.stop()
					.slideDown(300);
			} else {
				$(this).removeClass("active");
				$(this).siblings(".about__accordion-description").stop().slideUp(300);
			}
		});
  };

  const initZoomImage = () => {
    const imagesWrapper = document.querySelector('.product-media-modal__content');
    if (!imagesWrapper) return;
    const images = imagesWrapper.querySelectorAll('.js-image-zoom');

    images.forEach(el => {
      el.addEventListener('click', (e) => {
        imagesWrapper.classList.toggle('zoom');
      });
    })
  };

  document.addEventListener('shopify:section:load', function () {
    initProductAccordion();
    initZoomImage();
  });

  initProductAccordion();
  initZoomImage();

  // ---- COLOR BUBBLE SWIPER
  function hexToHsl(hex) {
    const r = parseInt(hex.slice(1, 3), 16) / 255;
    const g = parseInt(hex.slice(3, 5), 16) / 255;
    const b = parseInt(hex.slice(5, 7), 16) / 255;
    const max = Math.max(r, g, b), min = Math.min(r, g, b);
    const l = (max + min) / 2;
    if (max === min) return { h: 0, s: 0, l };
    const d = max - min;
    const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    let h;
    if (max === r)      h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
    else if (max === g) h = ((b - r) / d + 2) / 6;
    else                h = ((r - g) / d + 4) / 6;
    return { h: h * 360, s, l };
  }

  function sortColorBubbles(wrapper) {
    const toggle = wrapper.querySelector('[data-sus-bubbles-toggle]');
    const items = Array.from(wrapper.children).filter(el => el !== toggle);
    const active = items.find(s => s.classList.contains('active'));
    const rest = items.filter(s => !s.classList.contains('active'));

    rest.sort((a, b) => {
      const ha = hexToHsl(a.dataset.hex || '#808080');
      const hb = hexToHsl(b.dataset.hex || '#808080');
      // Primary: hue (0–360), secondary: lightness descending (dark first)
      if (Math.abs(ha.h - hb.h) > 15) return ha.h - hb.h;
      return ha.l - hb.l;
    });

    const ordered = active ? [active, ...rest] : rest;
    ordered.forEach(item => wrapper.appendChild(item));
    if (toggle) wrapper.appendChild(toggle);
  }

  function clampColorBubbles(grid) {
    const toggle = grid.querySelector('[data-sus-bubbles-toggle]');
    if (!toggle) return;

    // Reset to measure the natural, unclamped layout first.
    const items = Array.from(grid.children).filter(el => el !== toggle);
    items.forEach(el => { el.hidden = false; });
    toggle.hidden = true;

    const rowTops = [...new Set(items.map(el => el.offsetTop))].sort((a, b) => a - b);
    const capacity = rowTops.length > 2
      ? items.filter(el => el.offsetTop < rowTops[2]).length
      : items.length;

    if (items.length <= capacity) {
      grid.classList.remove('is-expanded');
      return;
    }

    toggle.hidden = false;
    const expanded = grid.classList.contains('is-expanded');
    toggle.setAttribute('aria-expanded', String(expanded));

    if (expanded) {
      toggle.textContent = toggle.dataset.labelLess;
      return;
    }

    // Reserve the toggle's own cell: show one fewer bubble than fits.
    const visibleCount = capacity - 1;
    items.forEach((el, i) => { el.hidden = i >= visibleCount; });
    toggle.textContent = `+${items.length - visibleCount} ${toggle.dataset.labelMore}`;
  }

  document.querySelectorAll('[data-sus-sort-bubbles]').forEach(sortColorBubbles);

  document.querySelectorAll('.product-sus-color-bubbles-grid').forEach(grid => {
    clampColorBubbles(grid);

    const toggle = grid.querySelector('[data-sus-bubbles-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        grid.classList.toggle('is-expanded');
        clampColorBubbles(grid);
      });
    }

    if (typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(() => clampColorBubbles(grid)).observe(grid);
    }
  });

  const bubbleSwiper = document.querySelector('.product-sus-color-bubbles-swiper');
  if (bubbleSwiper && typeof Swiper !== 'undefined') {
    const swiper = new Swiper(bubbleSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      simulateTouch: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: bubbleSwiper.querySelector('.swiper-button-next'),
        prevEl: bubbleSwiper.querySelector('.swiper-button-prev'),
      },
    });

    const bubbleContainer = bubbleSwiper.closest('.product-sus-color-bubbles');
    if (bubbleContainer && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(() => swiper.update()).observe(bubbleContainer);
    }
  }

  // ---- BACK-IN-STOCK NOTIFICATION TOGGLE
  const susProductForm = document.querySelector('[data-sus-product-form]');
  const sizeNotif      = document.getElementById('sus-product-size-notification');

  if (susProductForm && sizeNotif) {
    const notifyForm   = sizeNotif.querySelector('#size-notification');
    const deliveryDate = document.querySelector('.sus-delivery .sus_est_delivery_date');
    // const paylater     = document.querySelector('.paylater-message-container.paylater-message-product');
    const multiDisc    = document.querySelector('.sus_multi_discount');

    const setNotify = (show) => {
      susProductForm.hidden = show;
      sizeNotif.hidden   = !show;
      if (deliveryDate) deliveryDate.hidden = show;
      // if (paylater)     paylater.hidden     = show;
      if (multiDisc)    multiDisc.hidden    = show;
    };

    const evalRadio = (radio) => {
      const isNotify = radio.dataset.avail === 'false' && !('soldout' in radio.dataset);
      setNotify(isNotify);
      if (isNotify && notifyForm) {
        notifyForm.querySelector('input[name="variant_id"]').value = radio.dataset.id;
        notifyForm.querySelector('input[name="vsku"]').value       = radio.dataset.sku;
        notifyForm.querySelector('input[name="vtitle"]').value     = radio.value;
      }
    };

    document.addEventListener('click', (e) => {
      const label = e.target.closest('label.button--size');
      if (!label) return;
      const input = document.getElementById(label.htmlFor);
      if (input && ('cup' in input.dataset || 'pantySize' in input.dataset)) evalRadio(input);
    });

    const preChecked = document.querySelector('[data-cup]:checked, [data-panty-size]:checked');
    if (preChecked) evalRadio(preChecked);
  }

  // A/B Tests values must not contain ':' or '|' (use ',' for multiple values)
  window.oAbTests = window.oAbTests || {};
  function susAddAbTestProperty(sKey, sValue) {
    window.oAbTests[sKey] = sValue;
    const field = document.querySelector('[data-js-line-ab]');
    if (field) field.value = Object.entries(window.oAbTests).map(([k, v]) => k + ':' + v).join('|');
  }
  window.susAddAbTestProperty = susAddAbTestProperty;

  // A/B original state
  if (!Object.keys(window.oAbTests).length) {
    // sizeSystemSwitch = tabs ? radios
    if (document.querySelector('.sus-size-system-toggle-tabs')) susAddAbTestProperty('sswitch', 'tabs');
    // sizeReco = hidden ? visible
    if (document.querySelector('.sus-size-reco')) susAddAbTestProperty('sreco', 'hidden');
  }

})();
